export default __webpack_public_path__ + "static/media/user_profile_header.2abb9165.png";